<mat-form-field
  class="fill"
  [class.mat-form-field-invalid]="formControl.errors && formControl.touched"
>
  <mat-label [innerText]="to.label"></mat-label>
  <input
    id="ctrlSingleSearch"
    matInput
    type="text"
    [formlyAttributes]="field"
    [formControl]="currentSearchCtrl"
    [matAutocomplete]="search"
  />

  <mat-autocomplete (optionSelected)="changeSearch($event)" #search="matAutocomplete">
    @if (searchList.length > 0) {
      <mat-option disabled="true">
        <div class="row">
          @for (definition of columnDefinitions; track definition) {
            <div [class]="definition.classes">
              {{ translateService.instant(definition.labelTranslationKey) }}
            </div>
          }
        </div>
      </mat-option>
    }
    @for (option of searchList; track option) {
      <mat-option (click)="selectValue(option)" [value]="option">
        <div class="row">
          @for (definition of columnDefinitions; track definition) {
            <div [class]="definition.classes">
              {{ getOptionLabelFormatted(option, definition) }}
            </div>
          }
        </div>
      </mat-option>
    }
  </mat-autocomplete>
  @if (isVisibleInputWaiting) {
    <button mat-button matSuffix mat-icon-button>
      <mat-spinner [diameter]="20"></mat-spinner>
    </button>
  }
</mat-form-field>
<div class="preview">
  @for (definition of columnDefinitions; track definition) {
    <div class="row">
      <div class="col-3">{{ this.translateService.instant(definition.labelTranslationKey) }}</div>
      <div class="col-7">{{ getOptionLabelFormatted(selectedResult, definition) }}</div>
    </div>
  }
  @if (selectedResult) {
    <div class="delete" (click)="deleteSelected()">
      <mat-icon>delete</mat-icon>
    </div>
  }
</div>
